<template>
  <v-footer white>
    <v-container fluid
                 white>
      <v-layout row
                v-if="expandedFooter">
        <v-flex xs12>
          <v-card flat>
            <v-container grid-list-md>
              <v-layout row
                        wrap
                        justify-center
                        class="address-list">
                <template v-for="(item, index) in headquarters">
                  <v-flex xs12 :key="index">
                    <v-subheader class="justify-center">{{ item.city }}</v-subheader>
                    
                    <!-- Layout horizontal para tablets y pantallas medianas -->
                    <v-layout row wrap justify-center class="hidden-xs-only hidden-lg-and-up">
                      <v-flex xs12 sm4>
                        <v-list dense>
                          <v-list-tile :href="`${item.addressLink}`"
                                       target="_blank"
                                       class="address-list-dense"
                                       @click="trackEvent(`'contacto_${item.city}_address'`)">
                            <v-list-tile-action>
                              <v-icon>location_on</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.address1 }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ item.address2 }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                      
                      <v-flex xs12 sm4>
                        <v-list dense>
                          <v-list-tile :href="`mailto:${item.email}`"
                                       class="address-list-dense"
                                       @click="trackEvent(`'contacto_${item.city}_email'`)">
                            <v-list-tile-action>
                              <v-icon>mail</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.email }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                      
                      <v-flex xs12 sm4>
                        <v-list dense>
                          <v-list-tile :href="`tel:${item.phoneLink}`"
                                       class="address-list-dense"
                                       @click="trackEvent(`'contacto_${item.city}_phone'`)">
                            <v-list-tile-action>
                              <v-icon>phone</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.phone }}</v-list-tile-title>
                              <v-list-tile-sub-title>
                                <span v-html="item.phoneDescription"></span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                    
                    <!-- Layout centrado en una línea para pantallas grandes -->
                    <v-layout row wrap justify-center class="hidden-md-and-down">
                      <v-flex shrink>
                        <v-layout row align-center>
                          <v-list-tile :href="`${item.addressLink}`"
                                       target="_blank"
                                       class="address-list-dense inline-tile"
                                       @click="trackEvent(`'contacto_${item.city}_address'`)">
                            <v-list-tile-action>
                              <v-icon>location_on</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.address1 }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ item.address2 }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          
                          <v-divider vertical class="mx-3"></v-divider>
                          
                          <v-list-tile :href="`mailto:${item.email}`"
                                       class="address-list-dense inline-tile"
                                       @click="trackEvent(`'contacto_${item.city}_email'`)">
                            <v-list-tile-action>
                              <v-icon>mail</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.email }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          
                          <v-divider vertical class="mx-3"></v-divider>
                          
                          <v-list-tile :href="`tel:${item.phoneLink}`"
                                       class="address-list-dense inline-tile"
                                       @click="trackEvent(`'contacto_${item.city}_phone'`)">
                            <v-list-tile-action>
                              <v-icon>phone</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.phone }}</v-list-tile-title>
                              <v-list-tile-sub-title>
                                <span v-html="item.phoneDescription"></span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    
                    <!-- Layout vertical centrado para teléfonos -->
                    <v-layout column align-center class="hidden-sm-and-up">
                      <v-list two-line dense class="text-xs-center">
                        <v-list-tile :href="`${item.addressLink}`"
                                     target="_blank"
                                     class="address-list-dense centered-tile"
                                     @click="trackEvent(`'contacto_${item.city}_address'`)">
                          <v-list-tile-action>
                            <v-icon>location_on</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.address1 }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ item.address2 }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile :href="`mailto:${item.email}`"
                                     class="address-list-dense centered-tile"
                                     @click="trackEvent(`'contacto_${item.city}_email'`)">
                          <v-list-tile-action>
                            <v-icon>mail</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.email }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile :href="`tel:${item.phoneLink}`"
                                     class="address-list-dense centered-tile"
                                     @click="trackEvent(`'contacto_${item.city}_phone'`)">
                          <v-list-tile-action>
                            <v-icon>phone</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.phone }}</v-list-tile-title>
                            <v-list-tile-sub-title>
                              <span v-html="item.phoneDescription"></span>
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-layout>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row
                wrap
                pt-3
                justify-center
                white>
        <v-btn color="grey lighten-1"
               flat
               href="https://wesmartpark.com"
               target="_blank">
          wesmartPark
        </v-btn>

        <v-btn color="grey lighten-1"
               flat
               href="https://developers.wesmartpark.com"
               target="_blank">
          developers
        </v-btn>

        <v-btn color="grey lighten-1"
               flat
               href="https://www.linkedin.com/company/parkingmanagers-by-wesmartpark-"
               target="_blank">
          linkedIn
        </v-btn>

        <v-btn color="grey lighten-1"
               flat
               href="https://plus.google.com/113173029966147173561"
               target="_blank">
          google+
        </v-btn>

        <v-menu>
          <v-btn color="grey lighten-1"
                 flat
                 slot="activator"
                 target="_blank">
            Media
          </v-btn>

          <v-card>
            <v-list>
              <template v-for="me in media">
                <v-list-tile :key="me.name"
                             :href="`${me.link}`"
                             target="_blank">
                  <v-list-tile-action>
                    <img :src="`/static/img/media/${me.logo}`"
                         height="50" />

                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-menu>

        <v-flex xs12
                pb-3
                pt-1
                text-xs-center>
          <img src="/static/img/emprendetur.jpg"
               alt="Emprendetur"
               height="60px" />
          <img src="/static/img/enisa.jpg"
               alt="Enisa"
               height="60px" />
        </v-flex>

        <v-flex xs12
                pb-3
                pt-1
                text-xs-center
                grey--text>
          &copy;{{year}} — parkingManagers
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
import store from '@/store';

export default {
  name: 'dps-footer',
  components: {},
  props: ['expandedFooter'],
  data() {
    return {
      headquarters: store.state.headquarters,
      media: store.state.mediaLinks,
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
.inline-tile {
  width: auto !important;
  flex: none !important;
}

.centered-tile {
  justify-content: center !important;
}

.address-list-dense {
  padding: 8px 12px;
}

.v-subheader {
  justify-content: center;
}
</style>




// WEBPACK FOOTER //
// src/components/commons/Footer.vue